import React from 'react';
import s3ImageTransform from '@/shared/utils/s3ImageTransform';
import { isAssetTypeAnImage, isAssetTypePdf, isAssetTypePsd } from '@/shared/utils/utils';
import { handlePreview } from '../PreviewImage';

interface IProps {
  src: string;
  alt?: string;
  transform?: string;
  className?: string;
  disableClickAction?: boolean;
  onClick?: () => void;
  onError?: () => void;
  crossOrigin?: '' | 'anonymous';
  style?: any;
}

const SafeImage = ({
  src,
  alt,
  transform,
  className,
  disableClickAction,
  onClick,
  onError,
  crossOrigin,
  style,
}: IProps) => {
  const imageClick = (src: string) => {
    if (onClick) {
      onClick();
    } else {
      handlePreview({ urls: [src], current: 0 });
    }
  };

  const addDefaultSrc = (event, src) => {
    event.target.src = src;
    event.target.onError = () => onError?.();
  };

  const renderIcon = (src: string, img: string) => {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        className={className || ''}
        src={img}
        onClick={() => {
          window.open(src, '_blank');
        }}
        alt={alt}
      />
    );
  };

  if (isAssetTypePdf(src)) {
    return renderIcon(src, '/images/sourcing/open-pdf.png');
  }
  if (isAssetTypePsd(src)) {
    return renderIcon(src, '/svg/psd.svg');
  }

  const isImage = isAssetTypeAnImage(src);
  const imageSrc = !isImage ? '/images/file.png' : src;

  const renderImage = (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      className={className || ''}
      style={{ cursor: 'pointer', ...style }}
      alt={alt}
      crossOrigin={crossOrigin}
      onClick={() => {
        if (!isImage) {
          return;
        }
        if (disableClickAction) {
          onClick?.();
        } else {
          imageClick(src);
        }
      }}
      onError={(event) => {
        addDefaultSrc(event, src);
      }}
      src={s3ImageTransform(imageSrc, transform || 'grande')}
    />
  );

  const renderImageHref = (
    <a href={src} target="_blank" rel="noreferrer">
      {renderImage}
    </a>
  );

  return isImage ? renderImage : renderImageHref;
};

export default SafeImage;
